import { useQuery } from "@apollo/client";
import { useState, useEffect } from "react";
import {
  DashboardSkeleton,
  ErrorState,
} from "../../components/states";
import { GET_SUPER_DASH_DETAILS } from "../../graphql/companyQueries";
import Breadcrumb from "../../components/Breadcrumb";
import Card from "../../components/Card";
import MobileCard from "../../components/dashboard/MobileCard";
import StatGrid from "../../components/dashboard/StatGrid";
import TrendChart from "../../components/dashboard/TrendChart";
import { useToast } from "../../components/Toast/toastHook";
const AdminDashboard = () => {
  // const { loading, error, data } = useQuery(GET_COMPANY_USERS, {
  // 	variables: { companyId: userData.company._id },
  // });
  const { loading, error, data, refetch } = useQuery(GET_SUPER_DASH_DETAILS, {
    fetchPolicy: "no-cache",
  });

  const toast = useToast();

  if (error) toast("error", error.message);

  const [dashDetails, setDashDetails] = useState({
    totalActiveUsers: 0,
    totalAccountsAssigned: 0,
    percentAccountsActivated: 0,
    totalActiveListings: 0,
    totalListings: 0,
    agentsEnteringListing: 0,
    agentsEnteringBuyers: 0,
    totalBuyersEntered: 0,
    totalBuyerMatches: 0,
    listingsEntered: [],
    buyersMatches: [],
  });

  useEffect(() => {
    if (data) setDashDetails(data.getSuperUserDashboardDetails);
  }, [data]);

  if (loading)
    return (
      <div className="">
        <Breadcrumb pageName={"Dashboard"} />
        <DashboardSkeleton tileRows={[5, 4]} charts />
      </div>
    );

  if (error && !data)
    return (
      <div className="">
        <Breadcrumb pageName={"Dashboard"} />
        <ErrorState onRetry={() => refetch()} />
      </div>
    );

  return (
    <div className="">
      <Breadcrumb pageName={"Dashboard"} />

      <Card>
        <div className="p-4 sm:p-6">
          <div className="border-b-2 border-primary pb-2 mb-6 flex w-full justify-between items-center">
            <h1 className="text-3xl font-semibold text-secondary">Overview</h1>
          </div>
          <div className="flex flex-col gap-4">
            <StatGrid cols={5}>
              <MobileCard
                text="User Count"
                value={dashDetails.totalActiveUsers}
              />
              <MobileCard
                text="Accounts Assigned"
                value={dashDetails.totalAccountsAssigned}
              />
              <MobileCard
                text="Accounts Activated %"
                value={`${dashDetails.percentAccountsActivated?.toFixed(2)}%`}
              />
              <MobileCard
                text="Total Listings Entered"
                value={dashDetails.totalListings}
              />
              <MobileCard
                text="Active Listings"
                value={dashDetails.totalActiveListings}
              />
            </StatGrid>
            <StatGrid cols={4}>
              <MobileCard
                text="Total Agents Entering Listings"
                value={`${dashDetails.agentsEnteringListing?.toFixed(2)}%`}
              />
              <MobileCard
                text="Total Agents Entering Buyers"
                value={`${dashDetails.agentsEnteringBuyers?.toFixed(2)}%`}
              />
              <MobileCard
                text="Total # of Buyer Matches"
                value={dashDetails.totalBuyerMatches}
              />
              <MobileCard
                text="Total # of Buyers Entered"
                value={dashDetails.totalBuyersEntered}
              />
            </StatGrid>
            <div className="mt-4 grid grid-cols-1 gap-6 xl:grid-cols-2">
              <TrendChart
                data={dashDetails.listingsEntered}
                dataKey="listingsCreated"
                label="Total Listings Entered"
              />
              <TrendChart
                data={dashDetails.buyersMatches}
                dataKey="buyersMatched"
                label="Total Buyer Matches"
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default AdminDashboard;
